import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding recap #40: react-navigation with React Native",
  "description": "",
  "published": "2017-06-12T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-40-react-navigation-react-native/swizec/7640"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/channel/UCoyHgaeLLI7Knp7LDHOwZMw"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <p>{`I channeled my inner Darth Vader yet again. Still don't know why my sound is garbled on YouTube, but works on LiveEdu. They're both using the same stream 😕`}</p>
    <lite-youtube {...{
      "videoid": "OFx8tMvpNj0",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`This weekend, I wanted to try out `}<a parentName="p" {...{
        "href": "https://reactnavigation.org/"
      }}><inlineCode parentName="a">{`react-navigation`}</inlineCode></a>{` because I've heard a lot about it. Supposed to be the big new (official) thing since `}<inlineCode parentName="p">{`Navigator`}</inlineCode>{` was deprecated in April.`}</p>
    <p>{`So I set out to build a travel app. You say where you're going, app tells you what to pack. I have no idea where I'm going to get lists of what to pack for different situations, but it seemed like a good way to try react-navigation.`}</p>
    <p>{`Looks a bit like this:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/06/travel-app.gif",
        "alt": null
      }}></img></p>
    <p>{`Pictures are from Flickr. I figured out how to do that in `}<a parentName="p" {...{
        "href": "https://school.shoutem.com/lectures/build-react-native-music-app-tutorial-part1/"
      }}>{`my Music App tutorial`}</a>{`. Maybe I should make an opensource "show random pretty pic from Flickr" component. Seems useful 🤔`}</p>
    <p>{`Anyway, pics from Flickr, navigation done via `}<inlineCode parentName="p">{`react-navigation`}</inlineCode>{`, lists of choices done by hand. No biggie there… still not sure how I'm going to get packing recommendations.`}</p>
    <p>{`I wonder how difficult it would be to add crowdsourcing to the app… a bit of Firebase, some setup, a call or two… hmmmm. We'll see.`}</p>
    <p>{`Either way, expect an in-depth tutorial about all of this on `}<a parentName="p" {...{
        "href": "reactnative.school"
      }}>{`reactnative.school`}</a>{` come Tuesday. Maybe Wednesday if I decide to wait for my new laptop to arrive.`}</p>
    <p>{`Really, the hardest part of today's livecoding was dealing with my computer. Damn thing is so slow when running OBS and `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/connected-canon-dslr-webcam/swizec/7477"
      }}>{`connecting to my DSLR`}</a>{` that it took 15 minutes to compile the initial blank app.`}</p>
    <p>{`And animations were slow in the iOS simulator and interaction was painful and I could barely type in the chatroom and even the Flickr images were taking way too long to show up. Just watch the stream video; it's painful as hell.`}</p>
    <p>{`Reminds me of playing Resident Evil on my 166MHz machine with 16MB RAM back in middle school. I'd read books during the door opening animations.`}</p>
    <p>{`These ones:`}</p>
    <lite-youtube {...{
      "videoid": "ZNU29JfzKOI",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Yeah, that used to take 5 minutes on my computer in middle school :D`}</p>
    <p>{`Great game tho. Much fun.`}</p>
    <p>{`So yeah, fun livecoding, we made something pretty, then I ragequitted because I couldn't deal with my laptop anymore. Thank `}{`<`}{`insert nerd deity> that I'm getting a new one in the mail this Wednesday.`}</p>
    <p>{`Then all will be better, right?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      